var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPmp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.496 36.001A4.5 4.5 0 0 1 25 31.5V27H7v4.5A4.5 4.5 0 0 1 11.5 36a4.5 4.5 0 0 1-4.5 4.5V45h18v-4.5a4.5 4.5 0 0 1-4.504-4.499z",
    fill: "#05bfe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.204 8.193v17.614c5.133 0 9.295-3.942 9.296-8.805.001 4.863 4.163 8.805 9.296 8.805V8.193c-5.133 0-9.295 3.942-9.296 8.805-.001-4.863-4.163-8.805-9.296-8.805z",
    fill: "#ff610f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.053 8.028A6.528 6.528 0 0 0 19.461 8H7v18h3.558v-5.617h8.903c.199 0 .396 0 .592-.028C23.42 20.07 26 17.399 26 14.195s-2.58-5.876-5.947-6.16zM20 17.9h-9.5v-7.5H20c1.749 0 3.167 1.679 3.167 3.75S21.749 17.9 20 17.9z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 42l3.167 3H27zm0-12l15.833 15h-5.306L27 35.026zm8.49-3L46 36.956V42L30.167 27zM46 27v3l-3.167-3z",
    fill: "#4f17a8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h52v52H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmp);
export default __webpack_public_path__ + "static/media/pmp.4bc52c711fac72d5930a348f6d088312.svg";
export { ForwardRef as ReactComponent };